import { create_trigger } from '@/base/trigger'
export default {
  'lock': false,
  'hidden': false,
  'style': {
    'position': 'absolute',
    'width': 60,
    'height': 60,
    'left': 100,
    'top': 200,
    'border-radius': 0,
    'border-width': 0,
    'border-style': 'solid',
    'rotate': 0,
    'transform': 'rotate(0deg)',
    'border-color': '',
    'clip-path': 'none'
  },
  'file': {
    'key': 'http://wscdn.cloudapp.71360.com/95a2a5ec-0ca0-41e2-a280-bb45d5a00a60', // 原始url
    'filtereffect': 'original',
    'a': null,
    'server': 'Q',
    'orikey': 'http://wscdn.cloudapp.71360.com/95a2a5ec-0ca0-41e2-a280-bb45d5a00a60' // 裁剪后的url
  },
  'link': null,
  filterType: 0,
  filter: {
    'brightness': 0,
    'contrast': 0,
    'saturate': 0,
    'hueRotate': 0,
    'blur': 0
  },
  clipShape: '',
  'fit': 'cover', // cover / fill
  'cmpType': 'image',
  'type': 'basic_image',
  'name': '图片02'
}
